<script setup lang="ts">
defineProps<{
  columns: { key: string, label: string }[]
  rows: Record<string, string | boolean | number>[]
}>()
</script>

<template>
  <div class="self-stretch p-12 bg-emerald-950/20 rounded-[44px] outline -outline-offset-1 outline-white/10 backdrop-blur-xl flex flex-col justify-start items-start gap-10 overflow-hidden">
    <div class="self-stretch flex justify-between items-end gap-16">
      <!-- Features column -->
      <div class="w-60 py-6 flex flex-col justify-start items-start gap-12 shrink-0">
        <div class="self-stretch text-white text-[22px] font-semibold tracking-wide h-7 flex items-center">
          Features
        </div>
        <div class="self-stretch flex flex-col justify-center items-start gap-5">
          <template
            v-for="(row, index) in rows"
            :key="index"
          >
            <div class="self-stretch text-white/80 text-base font-medium capitalize leading-4 tracking-tight py-1">
              {{ row.feature }}
            </div>
            <div
              v-if="index < rows.length - 1"
              class="self-stretch h-px bg-white/10"
            />
          </template>
        </div>
      </div>

      <!-- Competitors and Velara columns -->
      <div class="flex-1 flex justify-center items-end gap-6">
        <div
          v-for="column in columns"
          :key="column.key"
          :class="[
            'flex-1 flex flex-col items-center min-w-0',
            column.key === 'velara'
              ? 'bg-emerald-950/40 rounded-[20px] outline outline-1 -outline-offset-1 outline-emerald-900/80 backdrop-blur-xl'
              : ''
          ]"
        >
          <div
            :class="[
              'text-center text-white text-xl font-semibold tracking-tight h-7 flex items-center justify-center',
              column.key === 'velara' ? 'mt-6' : ''
            ]"
          >
            {{ column.label }}
          </div>
          <div
            :class="[
              'self-stretch flex flex-col justify-center items-center gap-12',
              'py-6',
              column.key === 'velara' ? 'mb-1' : ''
            ]"
          >
            <!-- Hidden Features label for spacing alignment -->
            <div
              class="self-stretch opacity-0 text-white text-[22px] font-normal tracking-wide h-7"
              aria-hidden="true"
            >
              Features
            </div>
            <div class="self-stretch flex flex-col justify-center items-center gap-5">
              <template
                v-for="(row, rowIndex) in rows"
                :key="rowIndex"
              >
                <div class="h-6 flex items-center justify-center">
                  <div
                    v-if="row[column.key] === true"
                    class="w-6 h-6 bg-check"
                  />
                  <div
                    v-else-if="row[column.key] === false"
                    class="w-6 h-6 bg-cross"
                  />
                  <span
                    v-else
                    class="text-white/60 text-sm font-medium"
                  >{{ row[column.key] }}</span>
                </div>
                <div
                  v-if="rowIndex < rows.length - 1"
                  class="self-stretch h-px bg-white/10"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
